// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --text-secondary-color: #91b9cd;
  --active-color: #20a5d6;
  --primary-background-color: #000;
  --ui-border-color-dark: #3c5d80;
  --sidebar-transition: all 0.3s ease;
}
.ImageThumbnail.active {
  border-color: var(--active-color);
  box-shadow: none;
  transition: var(--sidebar-transition);
}
.ImageThumbnail {
  background-color: var(--primary-background-color);
  box-shadow: inset 0 0 0 1px var(--ui-border-color-dark);
  border: 2px solid transparent;
  border-radius: 12px;
  height: 135px;
  margin: 0 auto;
  padding: 5px;
  position: relative;
  transition: var(--sidebar-transition);
  width: 217px;
  -moz-background-clip: padding;
  -webkit-background-clip: padding;
  background-clip: padding-box;
}
.ImageThumbnail .image-thumbnail-loading-indicator {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -22px 0 0 -22px;
  display: block;
  width: 44px;
  height: 44px;
}
.ImageThumbnail .image-thumbnail-loading-indicator:after {
  content: " ";
  display: block;
  width: 32px;
  height: 32px;
  margin: 1px;
  border-radius: 50%;
  border: 5px solid var(--ui-border-color-dark);
  border-color: var(--ui-border-color-dark) transparent var(--ui-border-color-dark) transparent;
  animation: image-thumbnail-loading-indicator 1.2s linear infinite;
}
@-moz-keyframes image-thumbnail-loading-indicator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes image-thumbnail-loading-indicator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@-o-keyframes image-thumbnail-loading-indicator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes image-thumbnail-loading-indicator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.image-thumbnail-canvas {
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.image-thumbnail-canvas img {
  -webkit-user-drag: none;
  pointer-events: none;
}
.thumbnailLoadingIndicator {
  display: none;
  pointer-events: none;
  color: var(--text-secondary-color);
  height: 20px;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
}
.thumbnailLoadingIndicator.d-block {
  display: block;
}
.thumbnailLoadingIndicator p {
  text-align: center;
  font-size: 10pt;
}
.image-thumbnail-progress-bar {
  position: relative;
  width: 100%;
  height: 3px;
  top: -5px;
}
.image-thumbnail-progress-bar .image-thumbnail-progress-bar-inner {
  height: 100%;
  width: 0;
  border-radius: 5px;
  background-color: var(--active-color);
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/studyBrowser/ImageThumbnail.styl"],"names":[],"mappings":"AAAA;EACE,+BAAwB;EACxB,uBAAgB;EAChB,gCAA4B;EAC5B,+BAAwB;EACxB,mCAAsB;AACxB;AAEA;EACE,iCAAc;EACd,gBAAY;EACZ,qCAAY;AAAd;AAEA;EACE,iDAAkB;EAClB,uDAAY;EACZ,6BAAQ;EACR,mBAAe;EACf,aAAQ;EACR,cAAQ;EACR,YAAQ;EACR,kBAAU;EACV,qCAAY;EACZ,YAAO;EACP,6BAAsB;EACtB,gCAAyB;EACzB,4BAAiB;AAAnB;AAIE;EACE,kBAAU;EACV,SAAM;EACN,QAAK;EACL,uBAAQ;EACR,cAAS;EACT,WAAO;EACP,YAAQ;AAFZ;AAII;EACE,YAAS;EACT,cAAS;EACT,WAAO;EACP,YAAQ;EACR,WAAQ;EACR,kBAAe;EACf,6CAAQ;EACR,6FAAc;EACd,iEAAW;AAFjB;AAII;EACE;IACE,uBAAW;EAFjB;EAGI;IACE,yBAAW;EADjB;AACF;AAJI;EACE;IACE,uBAAW;EAMjB;EALI;IACE,yBAAW;EAOjB;AACF;AAZI;EACE;IACE,uBAAW;EAcjB;EAbI;IACE,yBAAW;EAejB;AACF;AApBI;EACE;IACE,uBAAW;EAsBjB;EArBI;IACE,yBAAW;EAuBjB;AACF;AApBA;EACE,YAAQ;EACR,gBAAU;EACV,aAAS;EACT,uBAAiB;AAsBnB;AApBE;EACE,uBAAmB;EACnB,oBAAgB;AAsBpB;AApBA;EACE,aAAS;EACT,oBAAgB;EAChB,kCAAO;EACP,YAAQ;EACR,WAAO;EACP,MAAK;EACL,OAAM;EACN,QAAO;EACP,SAAQ;EACR,YAAQ;EACR,kBAAU;AAsBZ;AApBE;EACE,cAAS;AAsBb;AApBE;EACE,kBAAY;EACZ,eAAW;AAsBf;AApBA;EACE,kBAAU;EACV,WAAO;EACP,WAAQ;EACR,SAAK;AAsBP;AApBE;EACE,YAAQ;EACR,QAAO;EACP,kBAAe;EACf,qCAAkB;AAsBtB","sourcesContent":[":root {\n  --text-secondary-color: #91B9CD;\n  --active-color: #20A5D6;\n  --primary-background-color: black;\n  --ui-border-color-dark: #3C5D80\n  --sidebar-transition: all 0.3s ease;\n}\n\n.ImageThumbnail.active\n  border-color: var(--active-color);\n  box-shadow: none\n  transition: var(--sidebar-transition);\n\n.ImageThumbnail\n  background-color: var(--primary-background-color);\n  box-shadow: inset 0 0 0 1px var(--ui-border-color-dark);\n  border: 2px solid transparent\n  border-radius: 12px\n  height: 135px\n  margin: 0 auto\n  padding 5px\n  position: relative\n  transition: var(--sidebar-transition);\n  width: 217px\n  -moz-background-clip: padding\n  -webkit-background-clip: padding\n  background-clip: padding-box\n\n  // Thumbnail Loading Indicator\n\n  .image-thumbnail-loading-indicator\n    position: absolute\n    left: 50%\n    top: 50%\n    margin: -22px 0 0 -22px\n    display: block\n    width: 44px\n    height: 44px\n\n    &:after\n      content: \" \"\n      display: block\n      width: 32px\n      height: 32px\n      margin: 1px\n      border-radius: 50%\n      border: 5px solid var(--ui-border-color-dark)\n      border-color: var(--ui-border-color-dark) transparent var(--ui-border-color-dark) transparent\n      animation: image-thumbnail-loading-indicator 1.2s linear infinite\n\n    @keyframes image-thumbnail-loading-indicator\n      0%\n        transform: rotate(0deg)\n      100%\n        transform: rotate(360deg)\n\n  // The End...\n\n.image-thumbnail-canvas\n  height: 100%\n  overflow: hidden\n  display: flex\n  justify-content: center\n\n  img\n    -webkit-user-drag: none\n    pointer-events: none\n\n.thumbnailLoadingIndicator\n  display: none\n  pointer-events: none\n  color: var(--text-secondary-color);\n  height: 20px\n  width: 100%\n  top: 0\n  left: 0\n  right: 0\n  bottom: 0\n  margin: auto\n  position: absolute\n\n  &.d-block\n    display: block;\n\n  p\n    text-align: center\n    font-size: 10pt\n\n.image-thumbnail-progress-bar\n  position: relative\n  width: 100%\n  height: 3px\n  top: -5px\n\n  .image-thumbnail-progress-bar-inner\n    height: 100%\n    width: 0\n    border-radius: 5px\n    background-color: var(--active-color);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
